import React from 'react';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  className = '',
}) => {
  if (orientation === 'vertical') {
    return <div className={`w-px self-stretch bg-[var(--border-subtle)] ${className}`} />;
  }
  return <div className={`h-px w-full bg-[var(--border-subtle)] ${className}`} />;
};

export default React.memo(Divider);
export type { DividerProps };
